// extracted by mini-css-extract-plugin
export default {"container":"SmallNavbar_container__J9rsu"};